/* global axios */

const base = accountId => `/api/v1/accounts/${accountId}/billing`;

export const billingWalletAPI = {
  show(accountId) {
    return axios.get(`${base(accountId)}/wallet`);
  },

  transactions(accountId, params = {}) {
    return axios.get(`${base(accountId)}/wallet/transactions`, { params });
  },

  packageTemplates(accountId) {
    return axios.get(`${base(accountId)}/wallet/package_templates`);
  },

  purchase(accountId, billingPackageTemplateId) {
    return axios.post(`${base(accountId)}/wallet/purchase`, {
      billing_package_template_id: billingPackageTemplateId,
    });
  },
};
